import { CreatedDateFilterEnum } from "~/types/createdDate";
import type { IOption } from "~/types/option";

export const labelByCreatedDateFilterEnum: Record<
  CreatedDateFilterEnum,
  string
> = {
  [CreatedDateFilterEnum.ALL]: "All",
  [CreatedDateFilterEnum.D1]: "< 1 day",
  [CreatedDateFilterEnum.D7]: "< 7 days",
  [CreatedDateFilterEnum.D30]: "< 30 days",
};

export const createdDateFilterOptions: IOption<CreatedDateFilterEnum>[] =
  Object.values(CreatedDateFilterEnum).map((value) => ({
    label: labelByCreatedDateFilterEnum[value],
    value,
  }));
